module.exports = __webpack_public_path__ + "static/media/trip-advisor-achievement.1f4a3a8b.jpg";